import type { ScaleSelectorProps } from "@qendo/profile/journal";
import { ScaleType } from "@qendo/trackables";
import { BooleanSelector, type BooleanSelectorProps } from "~/components/form/journal/scale/BooleanSelector";
import { CycleSelector, type CycleSelectorProps } from "~/components/form/journal/scale/CycleSelector";
import { MealSelector, type MealSelectorProps } from "~/components/form/journal/scale/MealSelector";
import { MoodSelector, type MoodSelectorProps } from "~/components/form/journal/scale/MoodSelector";
import { OneToTenSelector, type OneToTenSelectorProps } from "~/components/form/journal/scale/OneToTenSelector";
import {
    OneToThirtySelector,
    type OneToThirtySelectorProps,
} from "~/components/form/journal/scale/OneToThirtySelector";
import {
    OneToTwentySelector,
    type OneToTwentySelectorProps,
} from "~/components/form/journal/scale/OneToTwentySelector";
import { OvulationSelector, type OvulationSelectorProps } from "~/components/form/journal/scale/OvulationSelector";
import { SexSelector, type SexSelectorProps } from "~/components/form/journal/scale/SexSelector";
import { SleepSelector, type SleepSelectorProps } from "~/components/form/journal/scale/SleepSelector";
import {
    TemperatureSelector,
    type TemperatureSelectorProps,
} from "~/components/form/journal/scale/TemperatureSelector";
import { WaterSelector, type WaterSelectorProps } from "~/components/form/journal/scale/WaterSelector";
import { Nothing } from "~/components/permission/Nothing";

export type ScaleInputProps<S extends ScaleType> = {
    readonly scale: S;
} & ScaleSelectorProps<S>;

export const ScaleInput = <S extends ScaleType>({ scale, ...scaleProps }: ScaleInputProps<S>) => {
    switch (scale) {
        case ScaleType.boolean:
            return <BooleanSelector {...(scaleProps as unknown as BooleanSelectorProps)} />;
        case ScaleType.cycle:
            return <CycleSelector {...(scaleProps as unknown as CycleSelectorProps)} />;
        case ScaleType.meal:
            return <MealSelector {...(scaleProps as unknown as MealSelectorProps)} />;
        case ScaleType.mood:
            return <MoodSelector {...(scaleProps as unknown as MoodSelectorProps)} />;
        case ScaleType.ten:
            return <OneToTenSelector {...(scaleProps as unknown as OneToTenSelectorProps)} />;
        case ScaleType.twenty:
            return <OneToTwentySelector {...(scaleProps as unknown as OneToTwentySelectorProps)} />;
        case ScaleType.thirty:
            return <OneToThirtySelector {...(scaleProps as unknown as OneToThirtySelectorProps)} />;
        case ScaleType.ovulation:
            return <OvulationSelector {...(scaleProps as unknown as OvulationSelectorProps)} />;
        case ScaleType.sex:
            return <SexSelector {...(scaleProps as unknown as SexSelectorProps)} />;
        case ScaleType.sleep:
            return <SleepSelector {...(scaleProps as unknown as SleepSelectorProps)} />;
        case ScaleType.temperature:
            return <TemperatureSelector {...(scaleProps as unknown as TemperatureSelectorProps)} />;
        case ScaleType.water:
            return <WaterSelector {...(scaleProps as unknown as WaterSelectorProps)} />;
        default:
            return <Nothing />;
    }
};
